module.exports = __webpack_public_path__ + "img/follow_bg_02.0bedb98d.png";